<script setup lang="ts">
import { PhConfetti } from '@phosphor-icons/vue';
</script>

<template>
  <div>
    <ph-confetti class="art-successful-icon" weight="thin" />
  </div>
</template>

<style scoped>
.art-successful-icon {
  width: 10rem;
  height: 10rem;
}
</style>
